export const AllowedAssessmentAndWellBeingFeatures = {
    SRA: "Stress Risk Assessment"
};
